<template>
	<select class="rc-form-select" v-model="selectedValue" @change="changeSelect">
		<option disabled selected>Выберете</option>
		<option v-for="option in options" :key="option.id" :value="option.id">
			{{ option.label }}
		</option>
	</select>
</template>
<script>
export default {
	name: 'rc-select',
	props: {
		modelValue: [Number, String],
		options: {
			type: Array,
			default: () => []
		}
	},
	data() {
		return {
			selectedValue: null
		}
	},
	mounted() {
		if (this.modelValue) {
			this.selectedValue = this.modelValue
		}
	},
	methods: {
		changeSelect(e) {
			this.$emit('update', e.target.value)
		}
	}
}
</script>
<style scoped>
.rc-form-select {
	font-size: 1rem;
	padding: .5rem;
	background-color: #fff;
	border: 1px solid #0070d0;
	border-radius: 2px;
}
</style>